import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbLayoutScrollService,
  NbToastrService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ExerciseUser } from "../../models/exercise.model";
import { CustomParams } from "../../models/pagination";

import Quiz from "../../models/quiz.model";
import { QuizContentService } from "../../services/quiz-content.service";

@Component({
  selector: "ngx-view-quiz-test",
  styleUrls: ["./view-quiz-test.component.scss"],
  templateUrl: "./view-quiz-test.component.html",
})
export class ViewQuizTestComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() quizId?: string;

  @Input() exerciseUser?: ExerciseUser;
  @Output() onFinished?: EventEmitter<any> = new EventEmitter();
  @Output() onSubmitted?: EventEmitter<any> = new EventEmitter();

  quiz: Quiz = new Quiz();
  isTestQuiz = false;

  submitted = false;
  loading = false;
  lastQuiz = false;

  status() {
    if (this.loading) return "warning";

    if (!this.quiz.submitted) {
      return "info";
    } else {
      if (this.quiz.isCorrect) {
        return "success";
      } else {
        return "danger";
      }
    }
  }

  constructor(
    private quizService: QuizContentService,
    private toastrService: NbToastrService,
    private scrollService: NbLayoutScrollService
  ) {}

  ngOnInit() {
    if (this.quizId) {
      this.isTestQuiz = true;
    } else if (this.exerciseUser && this.exerciseUser.exQuizzes) {
      this.isTestQuiz = false;

      if (this.exerciseUser.noQuiz < this.exerciseUser.exQuizzes.length) {
        this.exerciseUser.lastQuizId =
          this.exerciseUser.exQuizzes[this.exerciseUser.noQuiz].quizId;
      } else {
        this.exerciseUser.lastQuizId = this.exerciseUser.exQuizzes[0].quizId;
      }

      this.quizId = this.exerciseUser.lastQuizId;
    }

    this.getQuiz(this.quizId);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getQuiz(id) {
    this.loading = true;
    this.quizService
      .loadQuestion(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.loading = false;
        if (data) {
          this.quiz = data;
          this.quiz.id = id;

          //Sync data
          if (
            environment.syncLive &&
            this.exerciseUser &&
            this.exerciseUser.id
          ) {
            this.quiz.exerciseUserId = this.exerciseUser.id;

            const content = {
              exerciseUserId: this.exerciseUser.id,
              quizId: this.quiz.id,
              type: this.quiz.type,
              title: this.quiz.title,
              question: this.quiz.question,
              answers: this.quiz.answers,
              createdBy: this.exerciseUser.createdBy,
            };

            this.quizService
              .createAttempt(content)
              .subscribe((result: CustomParams) => {
                this.quiz.exerciseUserQuizId = result.id;
              });
          }
        }
      });
  }

  submit() {
    this.loading = true;
    this.submitted = true;
    this.quiz.submitted = true;

    this.quizService
      .submitAnswer(this.quiz)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.quiz.isCorrect = data.isCorrect;
        this.quiz.resultAnswers = data.resultAnswers;
        this.quiz.valueAnswer = data.valueAnswer;
        this.quiz.explain = data.explain;

        this.showAnswer();

        this.onSubmitted.emit(this.quiz);

        //Sync data
        if (environment.syncLive && this.exerciseUser && this.exerciseUser.id) {
          const content = {
            id: this.quiz.exerciseUserQuizId,
            exerciseUserId: this.exerciseUser.id,
            quizId: this.quiz.id,
            inputAnswer: this.quiz.inputAnswer,
            selectedAnswers: this.quiz.selectedAnswers,
            isCorrect: this.quiz.isCorrect,
            resultAnswers: this.quiz.resultAnswers,
            valueAnswer: this.quiz.valueAnswer,
            explain: this.quiz.explain,
            createdBy: this.exerciseUser.createdBy,
          };

          this.quizService.updateAttempt(content).subscribe((result) => {
            // console.log("submitAnswer", result);
          });
        }

        this.loading = false;
        this.submitted = false;
      });
  }

  reload() {
    this.getQuiz(this.quizId);
  }

  next() {
    this.scrollService.scrollTo(0, 0);
    if (this.exerciseUser.noQuiz < this.exerciseUser.exQuizzes.length) {
      this.exerciseUser.lastQuizId =
        this.exerciseUser.exQuizzes[this.exerciseUser.noQuiz].quizId;

      this.quizId = this.exerciseUser.lastQuizId;
      this.reload();
    } else {
      //Finish exercise
      this.exerciseUser.lastQuizId = "";
      this.finish();
    }
  }

  finish() {
    this.onFinished.emit(this.exerciseUser);
  }

  private showAnswer() {
    if (this.quiz.isCorrect) {
      this.quiz.title = "Bạn đã trả lời đúng. Chúc mừng bạn!";
      this.showToast("success", "Trả lời đúng", "Xin chúc mừng!");
    } else {
      this.quiz.title = "Bạn đã trả lời sai. Xin vui lòng thử lại!";
      this.showToast("danger", "Trả lời sai", "Xin vui lòng thử lại!");
    }
    //Show correct answers
    this.quiz.answers.forEach((item) => {
      const objF = this.quiz.resultAnswers.find((el) => el == item.value);
      item.isCorrect = objF ? true : false;
    });
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
